var _clipPath, _linearGradient, _linearGradient2, _clipPath2, _linearGradient3, _clipPath3, _linearGradient4, _radialGradient, _clipPath4, _radialGradient2, _radialGradient3, _radialGradient4, _g, _path, _g2, _path2, _g3, _g4, _g5, _path3, _g6, _path4, _path5, _g7, _g8, _g9, _circle, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleChrome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 48,
    viewBox: "0 0 192 192",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 88
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 29.337,
    x2: 81.837,
    y1: 75.021,
    y2: 44.354
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a52714",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#a52714",
    stopOpacity: 0
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 110.872,
    x2: 52.538,
    y1: 164.495,
    y2: 130.329
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#055524",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#055524",
    stopOpacity: 0
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8 184h83.77l38.88-38.88v-29.12h-69.29l-53.36-91.52z"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 121.858,
    x2: 136.547,
    y1: 49.804,
    y2: 114.13
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ea6100",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ea6100",
    stopOpacity: 0
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m96 56 34.65 60-38.88 68h92.23v-128z"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e2723",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e2723",
    stopOpacity: 0
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 92.176,
    cy: 55.948,
    gradientUnits: "userSpaceOnUse",
    r: 84.078,
    xlinkHref: "#g"
  })), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.97 8v40.34l39.39 67.66 34.64-60h88v-48z"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 21.875,
    cy: 48.52,
    gradientUnits: "userSpaceOnUse",
    r: 78.044,
    xlinkHref: "#g"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: 95.844,
    cy: 96.138,
    gradientUnits: "userSpaceOnUse",
    r: 87.87
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#263238",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238",
    stopOpacity: 0
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: 34.286,
    cy: 32.014,
    gradientUnits: "userSpaceOnUse",
    r: 176.746
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.97 8v108h39.39l34.64-60h88v-48z",
    fill: "#db4437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.97 8v108h39.39l34.64-60h88v-48z",
    fill: "url(#b)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#a)",
    d: "m62.31 115.65-39.83-68.31-.58 1 39.54 67.8z",
    fill: "#3e2723",
    fillOpacity: 0.15
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8 184h83.77l38.88-38.88v-29.12h-69.29l-53.36-91.52z",
    fill: "#0f9d58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 184h83.77l38.88-38.88v-29.12h-69.29l-53.36-91.52z",
    fill: "url(#c)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#a)",
    d: "m129.84 117.33-.83-.48-38.39 67.15h1.15l38.1-66.64z",
    fill: "#263238",
    fillOpacity: 0.15
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m96 56 34.65 60-38.88 68h92.23v-128z",
    fill: "#ffcd40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96 56 34.65 60-38.88 68h92.23v-128z",
    fill: "url(#e)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m96 56 34.65 60-38.88 68h92.23v-128z",
    fill: "#ffcd40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96 56 34.65 60-38.88 68h92.23v-128z",
    fill: "url(#e)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.97 8v108h39.39l34.64-60h88v-48z",
    fill: "#db4437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.97 8v108h39.39l34.64-60h88v-48z",
    fill: "url(#b)"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#a)",
    d: "m96 56v20.95l78.4-20.95z",
    fill: "url(#h)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8 184h83.77l38.88-38.88v-29.12h-69.29l-53.36-91.52z",
    fill: "#0f9d58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 184h83.77l38.88-38.88v-29.12h-69.29l-53.36-91.52z",
    fill: "url(#c)"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#a)",
    d: "m21.97 48.45 57.25 57.24-17.86 10.31z",
    fill: "url(#j)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#a)",
    d: "m91.83 183.89 20.96-78.2 17.86 10.31z",
    fill: "url(#k)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    fill: "#f1f1f1",
    r: 40
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    fill: "#4285f4",
    r: 32
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m96 55c-22.09 0-40 17.91-40 40v1c0-22.09 17.91-40 40-40h88v-1z",
    fill: "#3e2723",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.6 116c-6.92 11.94-19.81 20-34.6 20-14.8 0-27.69-8.06-34.61-20h-.04l-53.35-91.52v1l53.36 91.52h.04c6.92 11.94 19.81 20 34.61 20 14.79 0 27.68-8.05 34.6-20h.05v-1z",
    fill: "#fff",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97 56c-.17 0-.33.02-.5.03 21.86.27 39.5 18.05 39.5 39.97s-17.64 39.7-39.5 39.97c.17 0 .33.03.5.03 22.09 0 40-17.91 40-40s-17.91-40-40-40z",
    fill: "#3e2723",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131 117.33c3.4-5.88 5.37-12.68 5.37-19.96 0-4.22-.66-8.28-1.87-12.09.95 3.42 1.5 7.01 1.5 10.73 0 7.28-1.97 14.08-5.37 19.96l.02.04-38.88 68h1.16l38.09-66.64z",
    fill: "#fff",
    fillOpacity: 0.2
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m96 9c48.43 0 87.72 39.13 87.99 87.5 0-.17.01-.33.01-.5 0-48.6-39.4-88-88-88s-88 39.4-88 88c0 .17.01.33.01.5.27-48.37 39.56-87.5 87.99-87.5z",
    fill: "#fff",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96 183c48.43 0 87.72-39.13 87.99-87.5 0 .17.01.33.01.5 0 48.6-39.4 88-88 88s-88-39.4-88-88c0-.17.01-.33.01-.5.27 48.37 39.56 87.5 87.99 87.5z",
    fill: "#3e2723",
    fillOpacity: 0.15
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    fill: "url(#l)",
    r: 88
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h192v192h-192z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleChrome);
export default __webpack_public_path__ + "static/media/google-chrome.733603026b72e1cec95c9a01fc757533.svg";
export { ForwardRef as ReactComponent };